module.exports = __webpack_public_path__ + "img/sections.f0f198b8.svg";